import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Check, Minus } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const features = ["Aides", "Abos", "Docs", "Budget", "IA"];
const competitors = [
  { name: "Papernest", features: [false, true, false, false, false] },
  { name: "Mes Allocs", features: [true, false, false, false, false] },
  { name: "Digiposte", features: [false, false, true, false, false] },
  { name: "Bankin", features: [false, false, false, true, false] },
  { name: "Skipya", features: [true, true, true, true, true], highlight: true }
];

export const ComparisonSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const { isDark } = useTheme();

  return (
    <section 
      id="comparison"
      className={`section-apple px-6 ${isDark ? 'bg-black' : 'bg-[#f5f5f7]'}`}
      data-testid="comparison-section"
    >
      <div className="max-w-[980px] mx-auto">
        {/* Headline */}
        <motion.div
          ref={ref}
          className="text-center mb-16"
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className={`text-[40px] sm:text-[48px] font-semibold tracking-[-0.03em] leading-[1.1] ${
            isDark ? 'text-[#f5f5f7]' : 'text-[#1d1d1f]'
          }`}>
            Pourquoi Skipya ?
          </h2>
        </motion.div>

        {/* Comparison table - Apple minimal */}
        <motion.div
          className="overflow-x-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <table className="w-full text-center">
            <thead>
              <tr>
                <th className={`py-4 text-left text-[13px] font-normal ${
                  isDark ? 'text-[#6e6e73]' : 'text-[#86868b]'
                }`}></th>
                {competitors.map((comp, i) => (
                  <th 
                    key={i} 
                    className={`py-4 text-[13px] font-medium ${
                      comp.highlight 
                        ? 'text-[#81d8d0]' 
                        : isDark ? 'text-[#6e6e73]' : 'text-[#86868b]'
                    }`}
                  >
                    {comp.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {features.map((feature, fIndex) => (
                <tr key={fIndex} className={`border-t ${isDark ? 'border-[#1d1d1d]' : 'border-[#e8e8ed]'}`}>
                  <td className={`py-4 text-left text-[15px] ${
                    isDark ? 'text-[#f5f5f7]' : 'text-[#1d1d1f]'
                  }`}>
                    {feature}
                  </td>
                  {competitors.map((comp, cIndex) => (
                    <td key={cIndex} className="py-4">
                      {comp.features[fIndex] ? (
                        <Check 
                          size={18} 
                          strokeWidth={1.5} 
                          className={`mx-auto ${comp.highlight ? 'text-[#81d8d0]' : 'text-[#86868b]'}`}
                        />
                      ) : (
                        <Minus size={18} strokeWidth={1} className="mx-auto text-[#3a3a3c]" />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>
  );
};

export default ComparisonSection;
